import { Button } from '@/components/ui/button.tsx'
import { cn } from '@/lib/utils.ts'
import { ImageIcon } from 'lucide-react'
import type * as React from 'react'
import { useState } from 'react'

interface ImageThumbnailProps {
  srcImage: string
  onClick: () => void
  disableClick: boolean
}

export const ImageThumbnail = ({ srcImage, onClick, disableClick }: ImageThumbnailProps) => {
  const [isLoaded, setIsLoaded] = useState(false)

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (disableClick) return
    onClick()
  }

  return (
    <Button
      type="button"
      onClick={(e) => handleClick(e)}
      variant="ghost"
      className={cn(
        'relative w-[120px] min-w-[120px] h-[60px] p-0 overflow-hidden rounded-none  shrink-0 flex items-center justify-center bg-tb-grey-100',
        disableClick ? 'cursor-default' : '',
      )}
    >
      <div className="relative w-full h-full">
        {!isLoaded && (
          <div
            data-testid="image-placeholder"
            className="absolute inset-0 flex items-center justify-center opacity-100 transition-opacity duration-300"
          >
            <ImageIcon className="w-8 h-8 text-gray-400" aria-hidden="true" />
          </div>
        )}

        <img
          src={srcImage}
          alt="Attachment"
          className={cn(
            'absolute inset-0 w-full h-full object-contain transition-opacity duration-300',
            isLoaded ? 'opacity-100' : 'opacity-0',
          )}
          onLoad={() => setIsLoaded(true)}
          onError={() => setIsLoaded(false)}
        />
      </div>
    </Button>
  )
}
